import { render } from "./StudentManagement.vue?vue&type=template&id=e7772cd6&scoped=true"
import script from "./StudentManagement.vue?vue&type=script&lang=js"
export * from "./StudentManagement.vue?vue&type=script&lang=js"

import "./StudentManagement.vue?vue&type=style&index=0&id=e7772cd6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7772cd6"]])

export default __exports__